import { ProviderControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";
import { ArchiveMutation } from "../../../hooks/useArchiveState";

/**
 *
 * @author Atish Bagate
 */
export const useArchiveReferralProvider = () =>
  useMutationWithLoading(async (param: ArchiveMutation) =>
    new ProviderControllerApi(getConfigObject()).updateProviderArchiveStatus(
      param.id,
      param.status,
      param.xTENANTID //xTENANTID
    )
  );
